<template>
    <v-app id="inspire">
        <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app>
            <v-list dense>
                <template v-for="item in items">
                    <v-list-group v-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
                        <v-list-tile slot="activator">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-for="(child, i) in item.children" :key="i" @click="$go_path(child.path.name)">
                            <v-list-tile-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ child.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-else :key="item.text" @click="$go_path(item.path.name)">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.text }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed>
            <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <span class="hidden-sm-and-down">钉钉管理后台</span>
            </v-toolbar-title>
            <!--<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" label="Search" class="hidden-sm-and-down"></v-text-field>-->
            <!--<v-spacer></v-spacer>-->
            <!--<v-btn icon>-->
            <!--<v-icon>apps</v-icon>-->
            <!--</v-btn>-->
            <!--<v-btn icon>-->
            <!--<v-icon>notifications</v-icon>-->
            <!--</v-btn>-->
            <!--<v-btn icon large>-->
            <!--<v-avatar size="32px" tile>-->
            <!--<img src="https://cdn.vuetifyjs.com/images/logos/logo.svg" alt="Vuetify">-->
            <!--</v-avatar>-->
            <!--</v-btn>-->
        </v-toolbar>
        <v-content style="padding-top:0;">
            <v-container fluid fill-height>
                <v-layout justify-center align-center>
                    <v-flex xs12>
                        <transition name="move" mode="out-in">
                            <keep-alive>
                                <router-view></router-view>
                            </keep-alive>
                        </transition>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
	export default {
		data: () => ({
			dialog: false,
			drawer: null,
			items: [
				{
					icon: 'keyboard_arrow_up',
					'icon-alt': 'keyboard_arrow_down',
					text: '考评',
					model: true,
					children: [
						{icon: 'people', text: '年度考评', path: {name: 'AnnualReview'}},
						{icon: 'call_missed_outgoing', text: '排行榜', path: {name: 'AnnualReviewRank'}}
					]
				},

			]
		}),
		props: {
			source: String
		},
	}
</script>